import React, { useState, useEffect } from "react";
import { useOutletContext, useParams, useNavigate } from "react-router-dom";
import DashboardHeader from "../../components/Other/DashboardHeader";
import LeaderboardSecton from "../../components/Other/LeaderboardSecton";
import LeagueShell from "./league/LeagueShell";
import { getGameFromSlug } from "../../api/user";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const GameLeaderboard = () => {

    const [sidebarToggle] = useOutletContext();
    const { slug } = useParams();
    const [loading, setLoading] = useState(false);
    const [game, setGame] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {

        const checkGameDates = (start_date, end_date) => {

            const endDate = new Date(end_date.replace(" ", "T")); // Parse game.end_date
            const startDate = new Date(start_date.replace(" ", "T")); // Parse game.start_date
            const today = new Date(); // Get today's date
            today.setHours(0, 0, 0, 0); // Set time to midnight to ignore time component

            if (today >= startDate && today <= endDate) {
                return true;
            } else {
                return false;
            }

        }

        const fetchGameId = async (slug) => {
            try {
                const response = await getGameFromSlug({ slug });
                const gameData = response?.data?.data;
                if (gameData) {
                    //if(checkGameDates(gameData.start_date, gameData.end_date)){
                        setGame(gameData);
                        setLoading(true);
                  //  }
                  //  else{
                      //  toast.error("League is not active");
                        // navigate("/contest/my-games");
                        // navigate("/contest/my-games", { state: { viewMode: "creator" } });
                  //  }
                } else {
                    //toast.error("League not found");
                    // navigate("/contest/my-games");
                  //  navigate("/contest/my-games", { state: { viewMode: "member" } });
                }
            } catch (error) {
                console.error("Error fetching game ID:", error);
            }
        };

        fetchGameId(slug);

    }, [slug]);

    return (
        <>
            {
                loading && (
                    <>
                        <DashboardHeader toggle={sidebarToggle}  {...(game && { game })} />
                        {/* Client Rev 2, Leaderboard 2: "Below the QUSHi header
                            show: PRIVATE LEAGUE / League title, followed by the
                            Leaderboard page title, all left aligned."
                            `compact` is the shell's eyebrow-plus-name mode — the
                            same one Portfolio and Watchlist use — so the two lines
                            above the page title are the identical component the
                            rest of the league uses, not a copy. */}
                        {/* Client Rev 3, mobile inside a private league,
                            Leaderboard: "I circled an area that needs to be
                            deleted, and everything needs to move up." The circled
                            area is THIS h1 — a second "Leaderboard" title, because
                            LeaderboardSecton already prints its own as the page
                            title, directly below. So the screen carried the word
                            twice with 108px of dead space between the two.
                            Measured at 390px BEFORE: 22px "Leaderboard" at y=148,
                            36px "Leaderboard" at y=256. Deleting this one leaves
                            the real page title, and everything under the identity
                            block moves up by ~125px. */}
                        <LeagueShell game={game} active="leaderboard" compact standalone>
                            {/* `game`, not just its id. The board needs the competition itself to
                                know whether this is a cash game — the client asked for
                                "Verified game performance" there rather than "Verified
                                league performance". Already in hand on this screen, so it
                                costs no extra request. */}
                            <LeaderboardSecton gameId={game?.id} slug={slug} game={game} />
                        </LeagueShell>
                    </>
                )
            }

        </>
    )

}

export default GameLeaderboard;